import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
// import { toast } from 'react-toastify';
import { listenToCall, doCall, showWebphone } from '../actions/call';
import { callTimer, imgError, toastErrorMsg, logData } from '../utils/utils';
import { set_userInteraction } from "../actions/common.js";
import ringing from '../assets/img/ringing.svg';
import onCall from '../assets/img/onCall.svg';
import noAvatar from '../assets/img/no-avatar.png';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";
import OnGoingCall from "./modals/OnGoingCall";

class AgentDetailsRow extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchFilter: '',
			showOnGoingcallModal: false,
			agentProperties: {},
			link_disabled: false,
		};
	}

	componentWillMount() {
		this._ismounted = true;
		if (this.props.user.busy && this.props.user.startTime) {
			this.showTimer(this.props.user.id, this.props.user.startTime, 'onCall');
		}
		if (!this.props.user.availability && this.props.user.unavailableTime >= 0) {
			this.showTimer(this.props.user.id, this.props.user.unavailableTime, 'unavailable');
		}
		if (!this.props.user.busy && this.props.user.availability && this.props.user.unavailableTime >= 0) {
			this.showTimer(this.props.user.id, this.props.user.unavailableTime, 'available');
		}
	}

	componentWillReceiveProps = (nextProps) => {
		// nextProps.agents.forEach(agent => {
		// 	if(agent.busy && agent.startTime){
		// 		this.showTimer(agent.id, agent.startTime, 'onCall');
		// 	}else{
		// 		if(!agent.busy && this.state[`timer${agent.id}_onCall`]){
		// 			clearInterval(this[`timer${agent.id}_onCall`]);
		// 			this.setState({
		// 				[`timer${agent.id}_onCall`]: null
		// 			}, () => {
		// 				this[`timer${agent.id}_onCall`] = null;
		// 			});
		// 		}
		// 	}
		// 	if(!agent.availability && agent.unavailableTime){
		// 		this.showTimer(agent.id, agent.unavailableTime, 'unavailable');
		// 	}else{
		// 		if(agent.availability && this.state[`timer${agent.id}_unavailable`]){
		// 			clearInterval(this[`timer${agent.id}_unavailable`]);
		// 			this.setState({
		// 				[`timer${agent.id}_unavailable`]: null
		// 			}, () => {
		// 				this[`timer${agent.id}_unavailable`] = null;
		// 			});
		// 		}
		// 	}
		// });
		if (nextProps.user != this.props.user) {
			const { user: agent } = nextProps;
			if (agent.busy && agent.startTime) {
				this.showTimer(agent.id, agent.startTime, 'onCall');
			} else {
				if (!agent.busy && this.state[`timer${agent.id}_onCall`]) {
					clearInterval(this[`timer${agent.id}_onCall`]);
					this.setState({
						[`timer${agent.id}_onCall`]: null
					}, () => {
						this[`timer${agent.id}_onCall`] = null;
					});
					
					// NEW: Listen and Hangout
					this.onCallDisconnected();
				}
			}

			if (!agent.busy && !agent.availability && agent.unavailableTime >= 0) {
				this.showTimer(agent.id, agent.unavailableTime, 'unavailable');
			} else {
				if ((agent.busy || agent.availability) && this.state[`timer${agent.id}_unavailable`]) {
					clearInterval(this[`timer${agent.id}_unavailable`]);
					this.setState({
						[`timer${agent.id}_unavailable`]: null
					}, () => {
						this[`timer${agent.id}_unavailable`] = null;
					});
				}
			}

			if (!agent.busy && agent.availability && agent.unavailableTime >= 0) {
				this.showTimer(agent.id, agent.unavailableTime, 'available');
			} else {
				if ((agent.busy || !agent.availability) && this.state[`timer${agent.id}_available`]) {
					clearInterval(this[`timer${agent.id}_available`]);
					this.setState({
						[`timer${agent.id}_available`]: null
					}, () => {
						this[`timer${agent.id}_available`] = null;
					});
				}
			}

		}
	}

	componentWillUnmount() {
		this._ismounted = false;
		if (this.state[`timer${this.props.user.id}_onCall`]) {
			clearInterval(this[`timer${this.props.user.id}_onCall`]);
		}
		if (this.state[`timer${this.props.user.id}_unavailable`]) {
			clearInterval(this[`timer${this.props.user.id}_unavailable`]);
		}
		if (this.state[`timer${this.props.user.id}_available`]) {
			clearInterval(this[`timer${this.props.user.id}_available`]);
		}
	}

	getTelephoneAvailability = (agent) => {
		let availability = {
			title: '',
			iconColor: ''
		};
		if (agent.busy && agent.didAnswer) {
			availability.title = this.props.translations.onCall[this.props.selectedLanguage];
			availability.iconColor = 'user-busy';
		}
		if (agent.busy && !agent.didAnswer) {
			if (typeof agent.didAnswer == 'undefined') {
				availability.title = this.props.translations.onCall[this.props.selectedLanguage];
			} else {
				availability.title = agent.type == "outgoing"
					? this.props.translations.callingTo[this.props.selectedLanguage]
					: this.props.translations.ringingFrom[this.props.selectedLanguage];
				availability.iconColor = 'user-busy';
			}
		}
		if (!agent.busy && !agent.availability) {
			availability.title = this.props.translations.unavailable[this.props.selectedLanguage];
			availability.iconColor = 'user-unavailable';
		}
		if (!agent.busy && agent.availability) {
			availability.title = this.props.translations.available[this.props.selectedLanguage];
			availability.iconColor = 'user-available';
		}
		return availability;
	}

	// check for user availability. if available then makes call
	/* OLD: Only Call or Listen.
	handlePhoneClick = (e) => {
		const idArr = e.target.id.split('_');
		const id = idArr[1];
		//const agentsAndSupervisors = [...this.props.agents, ...this.props.supervisors];
		const agentsAndSupervisors = [...this.props.agents];
		const { extension, busy, call_id, didAnswer } = agentsAndSupervisors.find(item => item.id == id);
		if (!busy) {
			if (extension !== this.props.agentInfo.extension) {
				this.makeCall(extension);
			}
		} else {
			if (extension !== this.props.agentInfo.extension && (didAnswer || typeof didAnswer == 'undefined')) {
				this.listenToCall(call_id);
			}
		}
	}
    */	
	
    //---------------------------------------------------------------------
    // NEW: Call or Open dialog with Listen or Hangout.
    // Llamar desde panel de supervisor, vista de Agentes por disponibilidad. 
    handlePhoneClick = (e) => {
      if (! this.state.link_disabled)
      {
        // console.log('CLICK no more!! AgentDetailsRows');
        this.state.link_disabled = true;
        setTimeout(() => { 
            this.state.link_disabled = false; 
            // console.log('CLICK ok!! AgentDetailsRows'); 
        }, 5000);
        
        const idArr = e.target.id.split("_");
        const id = idArr[1];
        // const agentsAndSupervisors = [...this.props.agents, ...this.props.supervisors];
        const agentsAndSupervisors = [...this.props.agents];
        const userData = agentsAndSupervisors.find(
          (item) => String(item.id) === id
        );
        const { extension, busy, call_id, didAnswer, online, availability } =
          userData;
        // debugger
        if (!busy && online && availability) {
          if (extension !== this.props.agentInfo.extension) {
            this.props.showWebphone(true);
            this.makeCall(extension);
          }
        } else {
          if (
            extension !== this.props.agentInfo.extension &&
            busy &&
            (didAnswer || typeof didAnswer === "undefined")
          ) {
            // this.listenToCall(call_id);
            this.userOnCall(userData);
          }
        }
      }
    };
    //---------------------------------------------------------------------

	makeCall = (phoneNumber) => {
		const payload = {
			phoneNumber,
			internalCall: true
		};
		this.props.doCall(payload);
	}

    //---------------------------------------------------------------------
    // NEW: Call or Open dialog with Listen or Hangout. 
    userOnCall = (user_Info) => {
        const onCallList = [this.props.agentsOnCallList];
        const userCall = onCallList[0].find(
            (item) => item.callData.agent_id === String(user_Info.id)
        );
        this.setState({
            agentProperties: {
                user_Info: user_Info,
                IVR_name: userCall&&userCall.callData.application_name,
            },
        });
        this.open("showOnGoingcallModal");
    };

    onCallDisconnected = () => {
      if (this.state.showOnGoingcallModal && !this.props.userInteracted) {
        toastErrorMsg(
          this.props.translations.noCall[this.props.selectedLanguage],
          this,
          "callFailedToast"
        );
        this.close("showOnGoingcallModal");
      }
      if (this.props.userInteracted) {
        this.props.set_userInteraction(false);
      }
    };
    //---------------------------------------------------------------------


	listenToCall = (call_id) => {
		const payload = { extension: this.props.agentInfo.extension, call_id };
		this.props.listenToCall(payload).then((res) => {
			if (!res.data.result) {
				toastErrorMsg(this.props.translations.callFailed[this.props.selectedLanguage], this, "callFailedToast");
			}
		}, (err) => {
			logData(err);
		});
	}

	showTimer = (id, startTime, type) => {
		if (!this[`timer${id}_${type}`] && startTime > 0) {
			const currentTime = moment();
			const startTimeObj = moment(startTime * 1000);
			let sec = currentTime.diff(startTimeObj, 'seconds');
			sec = Math.max(0, sec);

			this[`timer${id}_${type}`] = setInterval(() => {
				if (sec < (24 * 3600)) {
					sec = moment().diff(startTimeObj, 'seconds');
					sec = Math.max(0, sec);
					if (this._ismounted == true) {
						this.setState({
							[`timer${id}_${type}`]: callTimer(sec)
						});
					}
				}
				else {
					clearInterval([`timer${id}_${type}`]);
					this.setState({ [`timer${id}_${type}`]: -1 });
				}
			}, 1000);
		}

		if (startTime == 0) {
			this.setState({
				[`timer${id}_${type}`]: '-:-'
			});
		}
	}

    //---------------------------------------------------------------------
    // NEW: Call or Open dialog with Listen or Hangout. 
    open = (key) => {
      this.setState({ [key]: true });
    };
    close = (key) => {
      // console.log("Close Key Updating");
      this.setState({ [key]: false });
    };
    //---------------------------------------------------------------------

	render() {
		const {
			user,
			availability,
			type,
			translations,
			selectedLanguage
		} = this.props;
		return (
			<tr key={user.id} className="availability_row">
				<td style={{ wordBreak: 'break-all', width: 150 }}>
					<div className="user-icon pull-left">
						<img
							className={`img-rounded ${user.online ? '' : 'img_grayscale'}`}
							src={user.avatar || noAvatar}
							onError={imgError}
							alt={`${user.name} ${user.surname_1}`}
						/>
					</div>
					<div className="pull-left" style={{ width: 'calc(100% - 33px)', marginTop: 5, wordBreak: 'break-all' }}>
						{user.is_supervisor && <b>{user.extension} - {`${user.name} ${user.surname_1}`}</b>}
						{!user.is_supervisor && <span>{user.extension} - {`${user.name} ${user.surname_1}`}</span>}
					</div>
				</td>
				{(user.online || user.busy) && <td className="text-left" style={{ width: 150 }}>
				    <a
					  title={this.getTelephoneAvailability(user).title}
					  id={`${type}_${user.id}`}
					  onClick={this.handlePhoneClick}
					  // style={{cursor: ((user.busy && !user.didAnswer) || user.extension==this.props.agentInfo.extension) ? 'default' : 'pointer'}}
					  style={{ 
                        cursor: 
                          (user.busy && !user.didAnswer && typeof user.didAnswer !== "undefined") ||
                          user.extension === this.props.agentInfo.extension ||
                          !user.online 
                          // || (!user.availability && !user.busy)						  
						    ? 'default' 
						    : 'pointer' 
				      }}
					  className={`btn btn-link btn-link${this.props.theme} btn-lg user-status ${this.getTelephoneAvailability(user).iconColor}`}
					>
						{!user.busy && <span id={`${type}_${user.id}`} className="icon icon-phone" />}
						{/* {(user.busy && !user.didAnswer) && <img id={ `${type}_${user.id}` } src={ringing} height="24" alt="" />}
						{(user.busy && user.didAnswer) && <img id={ `${type}_${user.id}` } src={onCall} height="24" alt="" />} */}
						{(user.busy && !user.didAnswer && typeof user.didAnswer != 'undefined') && <img id={`${type}_${user.id}`} src={ringing} height="24" alt="" />}
						{(user.busy && (user.didAnswer || typeof user.didAnswer == 'undefined')) && <img id={`${type}_${user.id}`} src={onCall} height="24" alt="" />}
					</a>
					{(availability !== 'available' && !user.busy) &&
						<span style={{ fontSize: 11 }}>{user.reason || translations.unavailable[selectedLanguage]}</span>}
					{(availability == 'available' && !user.busy) &&
						<span style={{ fontSize: 11 }}>{translations.available[selectedLanguage]}</span>}
					{(user.busy && user.from) && <span>
						<span
							style={{ fontSize: 11 }}
							className={`icon ${user.type == "outgoing" ? 'icon-arrow-up' : 'icon-arrow-down'}`} />
						<span style={{ fontSize: 11 }}>
							{/* {user.didAnswer ? ''
									: `${user.extension == user.from
										? this.props.translations.callingTo[this.props.selectedLanguage]
										: this.props.translations.ringingFrom[this.props.selectedLanguage]} `} */}
							{user.type == "outgoing" ? user.to : user.from}
							{user.service_name ? ` (${user.service_name})` : ` (${translations.noService[selectedLanguage]})`}
						</span>
					</span>}
				</td>}
				{(user.online || user.busy) && <td style={{ width: 62, fontSize: 11, textAlign: "center" }}>
					{(user.busy && user.startTime) && <span>
						{(this.state[`timer${user.id}_onCall`] != -1) ? this.state[`timer${user.id}_onCall`] : translations.morethan24hr[selectedLanguage]}
					</span>}
					{(availability !== 'available' && user.unavailableTime >= 0 && !user.busy) && <span>
						{(this.state[`timer${user.id}_unavailable`] != -1) ? this.state[`timer${user.id}_unavailable`] : translations.morethan24hr[selectedLanguage]}
					</span>}
					{(!user.busy && user.availability && user.unavailableTime >= 0) && <span>
						{(this.state[`timer${user.id}_available`] != -1) ? this.state[`timer${user.id}_available`] : translations.morethan24hr[selectedLanguage]}
					</span>}

		            <OnGoingCall
                      showOnGoingcallModal={this.state.showOnGoingcallModal}
                      handleClose={() => this.close("showOnGoingcallModal")}
                      agentProperties={this.state.agentProperties}
                    />

				</td>}
			</tr>
		);
	}
}

function mapStateToProps(state) {
	return {
        userInteracted: state.common.userInteracted,
        agents: state.agentsAndSupervisors.agents,
        agentsOnCallList: state.agentsAndSupervisors.agentsOnCallList,
		supervisors: state.agentsAndSupervisors.supervisors,
		agentInfo: state.agentInfo,
		queuedCalls: state.queuedCalls.queuedCalls,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
		darkMode: state.common.darkMode,
        theme: state.common.theme,
	};
}

const mapDispatchToProps = {
	listenToCall,
	doCall,
	set_userInteraction,
	showWebphone
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentDetailsRow);



// WEBPACK FOOTER //
// ./src/agent/AgentDetailsRow.js